import {
  DEFAULT_CUSTOMER_SERVICE_PHONE,
  DEFAULT_CUSTOMER_SERVICE_PHONE2,
  DEFAULT_EMAIL,
  DEFAULT_EMAIL2,
  DefaultQrCodeUrl,
} from '~/utils/const';

import icpUrl from '~/assets/common/ICP.png';
// import gwaUrl from '~/assets/common/GWA.png';

import './index.css';

function Footer(): JSX.Element {
  return (
    <footer className="footer">
      <div className="footer-wrap">
        {/* 快速入口 */}
        <div className="footer-item">
          <div className="footer-item-title">快速入口</div>
          <div className="footer-item-list">
            <div className="footer-item-link quick-entry">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://jcaigc.cn"
                title="视频生产工作化2.0"
              >
                简创AIGC
              </a>
            </div>
            <div className="footer-item-link quick-entry">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://live.gogoshine.com"
                title="直播精彩不遗漏，智能切片秒出稿"
              >
                直播智能切片系统
              </a>
            </div>
          </div>
        </div>
        {/* 服务与支持 */}
        <div className="footer-item">
          <div className="footer-item-title">服务与支持</div>
          <div className="footer-item-list">
            <div className="footer-item-link">
              <span>售后服务：</span>
              <a target="_blank" rel="noopener noreferrer" href={`mailto:${DEFAULT_EMAIL}`}>
                {DEFAULT_EMAIL}
              </a>
            </div>
            <div className="footer-item-link">
              <span>商务合作：</span>
              <a target="_blank" rel="noopener noreferrer" href={`mailto:${DEFAULT_EMAIL2}`}>
                {DEFAULT_EMAIL2}
              </a>
            </div>
            <div className="footer-item-link">
              <span>工作时间：9:00-18:00（工作日）</span>
            </div>
          </div>
        </div>

        {/* 联系我们 */}
        <div className="footer-item">
          <div className="footer-item-title">联系我们</div>
          <div className="footer-item-list">
            <div className="footer-item-link">
              <span>客服电话1：</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`tel:${DEFAULT_CUSTOMER_SERVICE_PHONE}`}
              >
                {DEFAULT_CUSTOMER_SERVICE_PHONE}
              </a>
            </div>
            <div className="footer-item-link">
              <span>客服电话2：</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`tel:${DEFAULT_CUSTOMER_SERVICE_PHONE2}`}
              >
                {DEFAULT_CUSTOMER_SERVICE_PHONE2}
              </a>
            </div>
            <div className="footer-item-qrcode">
              <img
                className="footer-item-qrcodeImg"
                alt="微信公众号二维码"
                src={DefaultQrCodeUrl}
              />
              <div className="footer-item-qrcodeText">微信扫码关注</div>
            </div>
          </div>
        </div>  
      </div>
      <div className="footer-copyright">
        <span>&copy; 2026 深圳市逗赛科技有限责任公司所有</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          <img src={icpUrl} alt="ICP备案" />
          粤ICP备2025431894号-2
        </a>
        {/* <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002007400"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={gwaUrl} alt="公安备案" />
          粤公网安备44030002007400号
        </a> */}
        
        <div>
          <span>办公地址：</span>
          <span>深圳市龙华区民治街道馨园二期6栋10楼4号</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
